import { TransitionsNodePage, TransitionsPage } from './views';

const routes = [
    {
        path: '/transitions',
        name: 'transitions',
        component: TransitionsPage,
        meta: {
            title: 'Transitions',
        },
    },
    {
        path: '/transitions/:id/',
        name: 'transitions-node',
        component: TransitionsNodePage,
        meta: {
            title: 'Transitions node',
        },
    },
];

export default routes;
